module.exports = __webpack_public_path__ + "media/images/room_menu_icon/courses-878f94a689a9b8e1a3fbfe919d21abfd.png";